export default __webpack_public_path__ + "static/media/grid_1__03.6da8b90e.jpg";